import React, { useState, useEffect } from 'react';

function TomatoRefillTimer() {
  const [timeUntilReset, setTimeUntilReset] = useState('');
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const calculateTimeUntilReset = () => {
      const now = new Date();
      
      // Get midnight tonight (start of tomorrow)
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0); // This sets it to midnight tonight (start of next day)
      
      // Debug logging
      console.log('Timer Debug:', {
        now: now.toLocaleString(),
        midnight: midnight.toLocaleString(),
        currentHour: now.getHours(),
        currentMinutes: now.getMinutes()
      });
      
      const msUntilReset = midnight - now;
      const hoursUntilReset = Math.floor(msUntilReset / (1000 * 60 * 60));
      const minutesUntilReset = Math.floor((msUntilReset % (1000 * 60 * 60)) / (1000 * 60));
      
      // Calculate progress (0 at midnight, 100 at 11:59 PM)
      const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const msSinceMidnight = now - todayMidnight;
      const msInDay = 24 * 60 * 60 * 1000;
      const dayProgress = (msSinceMidnight / msInDay) * 100;
      
      setProgress(dayProgress);
      
      if (hoursUntilReset > 0) {
        setTimeUntilReset(`${hoursUntilReset}h ${minutesUntilReset}m`);
      } else {
        setTimeUntilReset(`${minutesUntilReset}m`);
      }
    };

    // Calculate immediately
    calculateTimeUntilReset();

    // Update every minute
    const interval = setInterval(calculateTimeUntilReset, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '20px',
      padding: '12px 16px',
      marginBottom: '20px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Progress bar background */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: `${progress}%`,
        backgroundColor: 'rgba(255, 107, 0, 0.3)',
        transition: 'width 1s ease-out',
        borderRadius: '20px'
      }} />
      
      {/* Content */}
      <div style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '14px',
        color: 'white'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>🍅</span>
          <span style={{ fontWeight: '600' }}>Daily Tomato Refill</span>
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          fontSize: '13px',
          opacity: 0.9
        }}>
          <span>in</span>
          <span style={{ fontWeight: '600' }}>{timeUntilReset}</span>
        </div>
      </div>
    </div>
  );
}

export default TomatoRefillTimer;